<template>
  <main v-if="progress" class="home mt-12">
    <div class="flex justify-between mb-10">
      <h1 class="font-Playfair text-[32px] leading-[42.66px] capitalize">{{ route.name.toLowerCase() }}</h1>
    </div>
    <div v-show="progress.onboarding === 'New'">
      <div class="flex flex-col xl:flex-row justify-between pt-4 text-sm text-gray-500">
        <div class="mr-16 mb-4">
          <h3 class="font-Rubik text-[18px] leading-[21.33px] font-medium text-black">The Business (Onboarding)</h3>
          <p class="font-Rubik text-[16px] leading-[24px] font-light w-[303px] mt-3">All responses provided will be cross-referenced and verified so make sure you are providing accurate and up-to-date responses.<br/> Kindly provide all the required information to proceed to the next stage.</p>
          <p class="font-Rubik text-[16px] leading-[24px] font-normal w-[303px] mt-2">Estimated completion time: <span class="text-black">5mins</span></p>
          <p class="font-Rubik text-[14px] leading-[24px] font-normal text-red-400 mt-2">*Required</p>
        </div>
        <div class="flex flex-col flex-grow lg:pb-10 pb-8">
          <div class="max-w-[613px]">
            <div class="relative w-full mb-6">
              <label
                class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                htmlFor="companyName"
              >
                <span class="text-red-400">*</span>
                Company Name
              </label>
              <input
                id="companyName"
                name="companyName"
                type="text"
                :class="[
                  v$.company_name.$error ? 'border-red-400' : 'border-grey-300',
                ]"
                class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                placeholder="Company XYZ"
                style="transition: 'all .15s ease'"
                v-model="v$.company_name.$model"
                @blur="v$.company_name.$touch()"
              />
              <div v-if="v$.company_name.$error">
                <p
                  v-if="v$.company_name.required.$invalid"
                  class="text-red-400 text-[10px] font-light"
                >Company Name is required</p>
                <p
                  v-if="v$.company_name.minLengthValue.$invalid"
                  class="text-red-400 text-[10px] font-light"
                >Company name should be at least 3 characters long</p>
              </div>
            </div>
            <div class="relative w-full mb-6">
              <label
                class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                htmlFor="websiteLink"
              >
                <span class="text-red-400">*</span>
                Link to Website
              </label>
              <input
                id="websiteLink"
                name="websiteLink"
                type="text"
                :class="[
                  v$.website.$error ? 'border-red-400' : 'border-grey-300',
                ]"
                class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                placeholder="https://companyxyz.com"
                style="transition: 'all .15s ease'"
                v-model="v$.website.$model"
                @blur="v$.website.$touch()"
              />
              <div v-if="v$.website.$error">
                <p
                  v-if="v$.website.required.$invalid"
                  class="text-red-400 text-[10px] font-light"
                >Website is required</p>
                <p
                  v-if="v$.website.url.$invalid"
                  class="text-red-400 text-[10px] font-light"
                >Website should be of form https://example.com</p>
              </div>
            </div>
            <div class="relative w-full mb-6">
              <label
                class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                htmlFor="yearFounded"
              >
                <span class="text-red-400">*</span>
                Year Founded
              </label>
              <input
                id="yearFounded"
                name="yearFounded"
                type="number"
                :class="[
                  v$.year_founded.$error ? 'border-red-400' : 'border-grey-300',
                ]"
                min="1500"
                max="2099"
                step="1"
                class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                placeholder="2000"
                style="transition: 'all .15s ease'"
                v-model="v$.year_founded.$model"
                @blur="v$.year_founded.$touch()"
              />
              <div v-if="v$.year_founded.$error">
                <p
                  v-if="v$.year_founded.required.$invalid"
                  class="text-red-400 text-[10px] font-light"
                >Year founded is required</p>
                <p
                  v-if="v$.year_founded.betweenValue.$invalid"
                  class="text-red-400 text-[10px] font-light"
                >{{v$.year_founded.betweenValue.$message}}</p>
                <div>
                </div>
              </div>
            </div>
            <div class="relative w-full mb-6">
              <label
                class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                htmlFor="companyName"
              >
                <span class="text-red-400">*</span>
                Company Summary
              </label>
              <textarea
                id="companySummary"
                name="companySummary"
                type="text"
                rows="3"
                maxlength="450"
                :class="[
                  v$.company_summary.$error ? 'border-red-400' : 'border-grey-300',
                ]"
                class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                placeholder="Please summarize what your company does in a paragraph or less"
                style="transition: 'all .15s ease'"
                v-model="v$.company_summary.$model"
                @blur="v$.company_summary.$touch()"
              />
              <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.company_summary.length} of 450`}}</span>
              <div v-if="v$.company_summary.$error">
                <p
                  v-if="v$.company_summary.required.$invalid"
                  class="text-red-400 text-[10px] font-light"
                >Company Summary is required</p>
                <p
                  v-if="v$.company_summary.minLengthValue.$invalid"
                  class="text-red-400 text-[10px] font-light"
                >Company summary should be at least 3 characters long</p>
              </div>
            </div>
            <div class="relative w-full mb-6">
              <div
                class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal mb-2"
                for="pitch-upload"
              >
                <span class="text-red-400">*</span>
                Pitch Deck
              </div>
              <div class="flex flex-row items-center">
                <label for="pitch-upload" class="flex items-center px-2 py-3 w-[max-content] relative cursor-pointer bg-white font-Rubik text-black rounded-sm border border-dashed focus:outline-none focus:border-black hover:border-black focus:ring-0">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                  </span>
                  Upload a File
                  <input
                    id="pitch-upload"
                    name="pitch-upload"
                    type="file"
                    accept="application/pdf"
                    class="sr-only"
                    @change="choosedata($event, 'pitch_deck', 'pitch_deck_type', 'PRESENTATION')"
                  >
                </label>
                <div class="ml-5 text-blueLink">
                  {{ files.pitch_deck }}
                </div>
              </div>
            </div>
            <div class="relative w-full mb-6">
              <div
                class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal mb-2"
                for="logo-upload"
              >
                <span class="text-red-400">*</span>
                logo
              </div>
              <div class="flex flex-row items-center">
                <label for="logo-upload" class="flex items-center px-2 py-3 w-[max-content] relative cursor-pointer bg-white font-Rubik text-black rounded-sm border border-dashed focus:outline-none focus:border-black hover:border-black focus:ring-0">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                  </span>
                  Upload Logo
                  <input
                    id="logo-upload"
                    name="logo-upload"
                    type="file"
                    accept="image/*"
                    class="sr-only"
                    @change="choosedata($event, 'logo', 'logo_type', 'PRESENTATION')"
                  >
                </label>
                <div class="ml-5 text-blueLink">
                  {{files.logo}}
                </div>
              </div>
            </div>
            <div class="relative w-full mb-6">
              <label
                class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                htmlFor="location"
              >
                <span class="text-red-400">*</span>
                Primary office location <span class="!text-xs">(Please enter full address)</span>
              </label>
              <input
                id="location"
                name="location"
                type="text"
                class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                placeholder="Type location"
                style="transition: 'all .15s ease'"
                v-model="v$.location.$model"
                @blur="v$.location.$touch()"
              />
              <div v-if="v$.location.$error">
                <p
                  v-if="v$.location.required.$invalid"
                  class="text-red-400 text-[10px] font-light"
                >Location is required</p>
              </div>
            </div>
            <div class="relative w-full mb-6 z-30">
              <Listbox
                v-model="v$.industry_type.$model"
              >
                <div class="relative mt-1">
                  <ListboxLabel class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal">
                    <span class="text-red-400">*</span>
                    Industry Type
                  </ListboxLabel>
                  <ListboxButton
                    @blur="v$.industry_type.$touch()"
                    :class="[
                      v$.industry_type.$error ? 'border-red-400' : 'border-grey-300',
                    ]"
                    class="relative px-4 py-4 mt-2 text-left placeholder-gray-400 text-black text-sm border border-gray-200 w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                  >
                    <span v-if="!v$.industry_type.$model" class="text-gray-400 block truncate">Select Industry Type</span>
                    <span v-else class="block truncate">{{ v$.industry_type.$model }}</span>
                    <span
                      class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
                    >
                      <SelectorIcon class="w-5 h-5 text-gray-400" aria-hidden="true" />
                    </span>
                  </ListboxButton>

                  <transition
                    leave-active-class="transition duration-100 ease-in"
                    leave-from-class="opacity-100"
                    leave-to-class="opacity-0"
                  >
                    <ListboxOptions
                      class="absolute w-full py-1 mt-1 overflow-auto text-base bg-white shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                    >
                      <ListboxOption
                        v-slot="{ active, selected }"
                        v-for="industry in industries"
                        :key="industry"
                        :value="industry"
                        as="template"
                      >
                        <li
                          :class="[
                            active ? 'text-white bg-black' : 'text-gray-900',
                            'cursor-default select-none relative py-2 pl-10 pr-4',
                          ]"
                        >
                          <span
                            :class="[
                              selected ? 'font-medium' : 'font-normal',
                              'block truncate',
                            ]"
                            >{{ industry }}</span
                          >
                          <span
                            v-if="selected"
                            class="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400"
                          >
                            <CheckIcon class="w-5 h-5" aria-hidden="true" />
                          </span>
                        </li>
                      </ListboxOption>
                    </ListboxOptions>
                  </transition>
                </div>
              </Listbox>
              <div v-if="v$.industry_type.$error">
                <p
                  v-if="v$.industry_type.required.$invalid"
                  class="text-red-400 text-[10px] font-light"
                >Industry type is required</p>
              </div>
            </div>
            <div class="relative w-full mb-6 z-20">
              <Listbox v-model="v$.business_model.$model">
                <div class="relative mt-1">
                  <ListboxLabel class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal">
                    <span class="text-red-400">*</span>
                    Business Model
                  </ListboxLabel>
                  <ListboxButton
                    @blur="v$.business_model.$touch()"
                    :class="[
                      v$.business_model.$error ? 'border-red-400' : 'border-grey-300',
                    ]"
                    class="relative px-4 py-4 mt-2 text-left placeholder-gray-400 text-black text-sm border border-gray-200 w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                  >
                    <span v-if="!v$.business_model.$model" class="block truncate text-gray-400">Select Business model</span>
                    <span v-else class="block truncate">{{ v$.business_model.$model }}</span>
                    <span
                      class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
                    >
                      <SelectorIcon class="w-5 h-5 text-gray-400" aria-hidden="true" />
                    </span>
                  </ListboxButton>

                  <transition
                    leave-active-class="transition duration-100 ease-in"
                    leave-from-class="opacity-100"
                    leave-to-class="opacity-0"
                  >
                    <ListboxOptions
                      class="absolute w-full py-1 mt-1 overflow-auto text-base bg-white shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                    >
                      <ListboxOption
                        v-slot="{ active, selected }"
                        v-for="model in businessmodel"
                        :key="model"
                        :value="model"
                        as="template"
                      >
                        <li
                          :class="[
                            active ? 'text-white bg-black' : 'text-gray-900',
                            'cursor-default select-none relative py-2 pl-10 pr-4',
                          ]"
                        >
                          <span
                            :class="[
                              selected ? 'font-medium' : 'font-normal',
                              'block truncate',
                            ]"
                            >{{ model }}</span
                          >
                          <span
                            v-if="selected"
                            class="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400"
                          >
                            <CheckIcon class="w-5 h-5" aria-hidden="true" />
                          </span>
                        </li>
                      </ListboxOption>
                    </ListboxOptions>
                  </transition>
                </div>
              </Listbox>
              <div v-if="v$.business_model.$error">
                <p
                  v-if="v$.business_model.required.$invalid"
                  class="text-red-400 text-[10px] font-light"
                >Business model is required</p>
              </div>
            </div>
            <div class="relative w-full mb-6 z-10">
              <Listbox v-model="v$.funding_round.$model">
                <div class="relative mt-1">
                  <ListboxLabel class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal">
                    <span class="text-red-400">*</span>
                    Funding Round
                  </ListboxLabel>
                  <ListboxButton
                    @blur="v$.funding_round.$touch()"
                    :class="[
                      v$.funding_round.$error ? 'border-red-400' : 'border-grey-300',
                    ]"
                    class="relative px-4 py-4 mt-2 text-left placeholder-gray-400 text-black text-sm border border-gray-200 w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                  >
                    <span v-if="!v$.funding_round.$model" class="text-gray-400 block truncate">Select Funding round</span>
                    <span v-else class="block truncate">{{ v$.funding_round.$model }}</span>
                    <span
                      class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
                    >
                      <SelectorIcon class="w-5 h-5 text-gray-400" aria-hidden="true" />
                    </span>
                  </ListboxButton>

                  <transition
                    leave-active-class="transition duration-100 ease-in"
                    leave-from-class="opacity-100"
                    leave-to-class="opacity-0"
                  >
                    <ListboxOptions
                      class="absolute w-full py-1 mt-1 overflow-auto text-base bg-white shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                    >
                      <ListboxOption
                        v-slot="{ active, selected }"
                        v-for="round in fundinground"
                        :key="round"
                        :value="round"
                        as="template"
                      >
                        <li
                          :class="[
                            active ? 'text-white bg-black' : 'text-gray-900',
                            'cursor-default select-none relative py-2 pl-10 pr-4',
                          ]"
                        >
                          <span
                            :class="[
                              selected ? 'font-medium' : 'font-normal',
                              'block truncate',
                            ]"
                            >{{ round }}</span
                          >
                          <span
                            v-if="selected"
                            class="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400"
                          >
                            <CheckIcon class="w-5 h-5" aria-hidden="true" />
                          </span>
                        </li>
                      </ListboxOption>
                    </ListboxOptions>
                  </transition>
                </div>
              </Listbox>
              <div v-if="v$.funding_round.$error">
                <p
                  v-if="v$.funding_round.required.$invalid"
                  class="text-red-400 text-[10px] font-light"
                >Funding round is required</p>
              </div>
            </div>
            <div class="relative w-full mb-6 z-[5]">
              <label
                class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                htmlFor="loacation"
              >
                <span class="text-red-400">*</span>
                Funding Type
              </label>
              <Listbox v-model="v$.funding_type.$model">
                <div class="relative mt-1">
                  <ListboxButton
                    @blur="v$.funding_type.$touch()"
                    :class="[
                      v$.funding_type.$error ? 'border-red-400' : 'border-grey-300',
                    ]"
                    class="relative px-4 py-4 mt-2 text-left placeholder-gray-400 text-black text-sm border border-gray-200 w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                  >
                    <span v-if="!v$.funding_type.$model" class="text-gray-400 block truncate">Select Funding type</span>
                    <span v-else class="block truncate">{{ v$.funding_type.$model }}</span>
                    <span
                      class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
                    >
                      <SelectorIcon class="w-5 h-5 text-gray-400" aria-hidden="true" />
                    </span>
                  </ListboxButton>

                  <transition
                    leave-active-class="transition duration-100 ease-in"
                    leave-from-class="opacity-100"
                    leave-to-class="opacity-0"
                  >
                    <ListboxOptions
                      class="absolute w-full py-1 mt-1 overflow-auto text-base bg-white shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                    >
                      <ListboxOption
                        v-slot="{ active, selected }"
                        v-for="type in fundingtype"
                        :key="type"
                        :value="type"
                        as="template"
                      >
                        <li
                          :class="[
                            active ? 'text-white bg-black' : 'text-gray-900',
                            'cursor-default select-none relative py-2 pl-10 pr-4',
                          ]"
                        >
                          <span
                            :class="[
                              selected ? 'font-medium' : 'font-normal',
                              'block truncate',
                            ]"
                            >{{ type }}</span
                          >
                          <span
                            v-if="selected"
                            class="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400"
                          >
                            <CheckIcon class="w-5 h-5" aria-hidden="true" />
                          </span>
                        </li>
                      </ListboxOption>
                    </ListboxOptions>
                  </transition>
                </div>
              </Listbox>
              <div v-if="v$.funding_type.$error">
                <p
                  v-if="v$.funding_type.required.$invalid"
                  class="text-red-400 text-[10px] font-light"
                >Funding type is required</p>
              </div>
            </div>
            <div class="relative w-full mb-12">
              <label
                class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                htmlFor="fundingSlider"
              >
                <span class="text-red-400">*</span>
                How much would you like Kinfolk to invest?
              </label>
              <input id="fundingSlider" type="range" min="0" max="1500000" v-model.number="data.max_amount" step="10000" />
              <div id="selector" class="h-[100px] w-[40px] absolute bottom-[-9px] left-[0%] z-[2] translate-x-[-50%]">
                <div id="selectBtn" class="h-[30px] w-[30px] bg-black rounded-full absolute bottom-0 left-0"></div>
                <div id="selectValue" class="currentValue w-[80px] h-[20px] absolute bottom-[-30px] left-[-30px] rounded-[4px] text-center leading-[18.96px] font-medium text-Rubik text-[15px] text-black">${{Helpers.numberWithCommas(data.max_amount)}}</div>
              </div>
              <div id="progressBar" class="w-0 h-[4px] bg-black rounded-[3px] absolute top-[31px]"></div>
            </div>
            <div class="relative flex justify-end w-full mb-6">
              <!-- <button
                class="flex bg-faintGrey text-[#666666] hover:text-black rounded-[6px] text-[16px] leading-[24px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50 mr-10"
                @click="onSaveDraft"
              >
                Save draft
              </button> -->
              <button
                :disabled="v$.$invalid"
                class="flex bg-black text-white rounded-[6px] text-[16px] leading-[24px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50"
                @click="onSubmit"
              >
                <span :class="loading ? 'mr-2' : 'mr-0'" class="text-white">Submit</span>
                <svg v-if="loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="20px" height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                  <circle cx="50" cy="50" fill="none" stroke="#ffffff" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                  </circle>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="progress.onboarding === 'Processing'">
      <div class="flex items-center justify-center w-full min-h-[370px]">
        <div class="flex flex-col justify-center items-center">
          <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.0578 26.2933L14.5822 23.4978C12.92 26.5956 11.9378 30.1467 11.9378 34C11.9378 39.2133 13.7511 44.0489 16.8489 47.8267L7.63111 48.1289L9.21778 57.1956C3.55111 51.1511 0 42.9911 0 34C0 27.4267 1.88889 21.2311 5.13778 16.0178L1.58667 13.2222L17.4533 10.5022L18.0578 26.2933ZM49.8667 41.6311L53.3422 44.4267C55.0044 41.3289 55.9867 37.7778 55.9867 33.9244C55.9867 28.7111 54.1733 23.8756 51.0756 20.0978L60.3689 19.7956L58.7822 10.8044C64.4489 16.8489 68 25.0089 68 34C68 40.5733 66.1111 46.7689 62.8622 51.9822L66.4133 54.7778L50.5467 57.4978L49.8667 41.6311ZM41.6311 18.0578L44.4267 14.5822C41.3289 12.92 37.7778 11.9378 33.9244 11.9378C28.7111 11.9378 23.8756 13.7511 20.0978 16.8489L19.7956 7.63111L10.8044 9.21778C16.8489 3.55111 25.0089 0 34 0C40.5733 0 46.7689 1.88889 51.9822 5.13778L54.7778 1.58667L57.4978 17.4533L41.6311 18.0578ZM26.2933 49.8667L23.4978 53.4178C26.5956 55.08 30.1467 56.0622 34 56.0622C39.2133 56.0622 44.0489 54.2489 47.8267 51.1511L48.1289 60.3689L57.12 58.7822C51.0756 64.4489 42.9156 68 33.9244 68C27.3511 68 21.1556 66.1111 15.9422 62.8622L13.1467 66.4133L10.4267 50.5467L26.2933 49.8667Z" fill="#B5B540"/>
          </svg>
          <p class="w-[210px] mt-4 font-Rubik text-[13px] leading-[20px] text-greyText text-center">The documents provided within this stage are still being processed</p>
        </div>
      </div>
    </div>
    <div v-show="progress.onboarding ===  'Approved'" class="flex flex-col justify-between pt-4 pb-2 text-sm text-gray-500">
      <div class="my-[120px]">
        <div class="flex flex-col justify-center items-center">
          <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M86.05 49.1344L84.3955 46.8684C83.0287 44.9981 83.0107 42.4624 84.3415 40.5561L85.9601 38.2721C87.8304 35.6105 86.9672 31.9238 84.0897 30.3772L81.626 29.0464C79.5758 27.9494 78.4608 25.6654 78.8384 23.3815L79.306 20.6119C79.8456 17.4108 77.4537 14.4435 74.1986 14.3176L71.3931 14.1917C69.0732 14.1018 67.077 12.5192 66.4296 10.2892L65.6563 7.5916C64.7571 4.46241 61.3221 2.84386 58.3188 4.1387L55.7471 5.2537C53.6071 6.17088 51.1433 5.63136 49.5787 3.88692L47.7083 1.80079C45.5323 -0.627032 41.7377 -0.591065 39.5976 1.85474L37.7633 3.97684C36.2346 5.72128 33.7708 6.31475 31.6307 5.43354L29.0411 4.37249C26.0378 3.1316 22.6208 4.8041 21.7576 7.95128L21.0203 10.6489C20.4268 12.9148 18.4665 14.5154 16.1466 14.6413L13.3411 14.8031C10.0861 14.983 7.74815 17.9863 8.34162 21.1694L8.84517 23.921C9.25879 26.2049 8.17976 28.5069 6.14758 29.6219L3.70177 30.9886C0.860321 32.5712 0.0330622 36.2759 1.95734 38.9015L3.61186 41.1675C4.97863 43.0378 4.99661 45.5736 3.66581 47.4799L2.04726 49.7638C0.176933 52.4254 1.04016 56.1121 3.91758 57.6587L6.38137 58.9895C8.43154 60.0866 9.54654 62.3705 9.16888 64.6545L8.68331 67.406C8.14379 70.6071 10.5357 73.5745 13.7907 73.7004L16.5962 73.8263C18.9161 73.9162 20.9124 75.4988 21.5598 77.7288L22.3331 80.4263C23.2323 83.5555 26.6672 85.1741 29.6705 83.8792L32.2422 82.7642C34.3823 81.8471 36.8461 82.3866 38.4107 84.113L40.281 86.1992C42.457 88.627 46.2517 88.591 48.3917 86.1452L50.2261 84.0231C51.7547 82.2787 54.2185 81.6852 56.3586 82.5664L58.9483 83.6275C61.9516 84.8684 65.3685 83.1959 66.2317 80.0487L66.9691 77.3511C67.5805 75.1211 69.5588 73.5205 71.8787 73.3767L74.6842 73.2148C77.9393 73.035 80.2772 70.0317 79.6837 66.8485L79.1801 64.097C78.7665 61.813 79.8455 59.5111 81.8777 58.3961L84.3235 57.0293C87.147 55.4827 87.9563 51.76 86.05 49.1344ZM44.0037 72.4235C28.3217 72.4235 15.6071 59.7089 15.6071 44.027C15.6071 28.345 28.3217 15.6304 44.0037 15.6304C59.6856 15.6304 72.4002 28.345 72.4002 44.027C72.4002 59.7089 59.6856 72.4235 44.0037 72.4235Z" fill="#40B540"/>
            <path d="M40.3707 44.7821L37.8529 42.2464C36.3603 40.7357 33.9144 40.7357 32.4038 42.2284C30.8932 43.721 30.8932 46.1668 32.3858 47.6775L34.9036 50.2132L37.709 53.0187C39.1657 54.4934 41.5396 54.4934 43.0143 53.0367L45.8198 50.2492L55.603 40.5199C57.1137 39.0272 57.1137 36.5814 55.621 35.0708C54.1283 33.5601 51.6825 33.5601 50.1719 35.0528L40.3707 44.7821Z" fill="#40B540"/>
          </svg>
          <p class="w-[210px] mt-4 font-Rubik text-[13px] leading-[20px] text-greyText text-center">You have completed this stage of the diligence process</p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import CompanyService from '@/services/company.service'
import { useRoute, useRouter } from 'vue-router'
import {
  Listbox,
  ListboxLabel,
  ListboxButton,
  ListboxOptions,
  ListboxOption
} from '@headlessui/vue'
import { CheckIcon, SelectorIcon } from '@heroicons/vue/solid'
import { ref, reactive, computed, onMounted } from 'vue'
import industries from '@/utils/industries'
import businessmodel from '@/utils/businessmodels'
import fundinground from '@/utils/fundinground'
import fundingtype from '@/utils/fundingtype'
import useVuelidate from '@vuelidate/core'
import { required, url, between, minLength } from '@vuelidate/validators'
import Helpers from '../../utils/helpers'
import { useStore } from 'vuex'
export default {
  components: {
    Listbox,
    ListboxLabel,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    CheckIcon,
    SelectorIcon
  },
  setup () {
    const route = useRoute()
    const store = useStore()
    const router = useRouter()
    const disabled = reactive({
      stage1: true,
      stage2: false,
      stage3: true
    })
    const files = ref({
      pitch_deck: null,
      logo: null
    })
    const loading = ref(false)

    const data = reactive({
      company_name: '',
      company_summary: '',
      website: '',
      year_founded: '',
      location: '',
      address: {},
      coordinates: '',
      pitch_deck: '',
      pitch_deck_type: '',
      logo: '',
      logo_type: '',
      industry_type: '',
      business_model: '',
      funding_round: '',
      funding_type: '',
      min_amount: 0,
      max_amount: 200000
    })
    const rules = computed(() => ({
      company_name: {
        required,
        minLengthValue: minLength(3)
      },
      company_summary: {
        required,
        minLengthValue: minLength(3)
      },
      website: { required, url },
      year_founded: {
        required,
        betweenValue: between(1500, 2099)
      },
      location: { required },
      pitch_deck: { required },
      logo: { required },
      industry_type: { required },
      business_model: { required },
      funding_round: { required },
      funding_type: { required },
      min_amount: { required },
      max_amount: { required }
    }))

    /**
     * @param {object} event - file event
     * @param {string} name - The name of the file ref
     * @param {string} type - The type of file eg(Legal)
     */
    const choosedata = (event, name, type, category) => {
      if (event.target.files[0]) {
        // console.log('FIELD', name, type)
        data[name] = event.target.files[0]
        data[type] = category
        files.value[name] = event.target.files[0].name
        // console.log(files.value)
        // console.log(data)
      }
    }
    function getLocation () {
      const locationinput = document.getElementById('location')
      // eslint-disable-next-line no-undef
      const loc = new google.maps.places.Autocomplete(locationinput)
      loc.addListener('place_changed', () => {
        const place = loc.getPlace()
        // console.log(place)
        const filteredPlace = Helpers.extractAddress(place)
        // console.log(filteredPlace)
        data.location = filteredPlace.formatted_address
        data.address = filteredPlace.address
        data.coordinates = filteredPlace.coordinates
        // console.log(data)
      })
    }
    const effectSlider = () => {
      const mainSlider = document.getElementById('fundingSlider')
      const selector = document.getElementById('selector')
      const selectValue = document.getElementById('selectValue')
      const progressBar = document.getElementById('progressBar')
      data.max_amount = Number(mainSlider.value)
      const min = mainSlider.min
      const max = mainSlider.max
      const newVal = Number(100 / (max - min) * (max - mainSlider.value))
      const newPosition = parseFloat(100 - (newVal * 0.99))
      selector.style.left = `${newPosition}%`
      progressBar.style.width = `${newPosition}%`
      mainSlider.oninput = () => {
        const newVal = Number(100 / (max - min) * (max - mainSlider.value))
        const newPosition = parseFloat(100 - (newVal * 0.99))
        selector.style.left = `${newPosition}%`
        progressBar.style.width = `${newPosition}%`
        data.max_amount = Number(mainSlider.value)
        selectValue.innerHTML = `$${Helpers.numberWithCommas(mainSlider.value)}`
      }
    }
    const v$ = useVuelidate(rules, data)
    const user_id = store.state.auth.user.id

    const onSubmit = async () => {
      loading.value = true
      const year_founded = Number(data.year_founded)
      const formData = new FormData()
      formData.append('user_id', user_id)
      formData.append('company_name', data.company_name)
      formData.append('company_summary', data.company_summary)
      formData.append('website', data.website)
      formData.append('year_founded', year_founded)
      formData.append('formatted_address', data.location)
      formData.append('address[city]', data.address.city)
      formData.append('address[state]', data.address.state)
      formData.append('address[country]', data.address.country)
      formData.append('address[code]', data.address.code)
      formData.append('pitch_deck', data.pitch_deck)
      formData.append('pitch_deck_type', data.pitch_deck_type)
      formData.append('logo', data.logo)
      formData.append('logo_type', data.logo_type)
      formData.append('coordinates[type]', 'Point')
      formData.append('coordinates[coordinates][]', data.coordinates.coordinates[0])
      formData.append('coordinates[coordinates][]', data.coordinates.coordinates[1])
      formData.append('industry_type', data.industry_type)
      formData.append('business_model', data.business_model)
      formData.append('funding_round', data.funding_round)
      formData.append('funding_type', data.funding_type)
      formData.append('min_amount', data.min_amount)
      formData.append('max_amount', data.max_amount)

      try {
        const response = await CompanyService.createCompany(formData)
        // console.log(response)
        if (response.status === 200 && response.data.status === 'success') {
          loading.value = false
          const success = {
            status: true,
            message: 'Your data has been submitted successfully. We will review and reach out to you within the next 24 to 48 hours. '
          }
          store.commit('setSuccess', success)

          store.commit('setCompany', response.data.data.company)
          store.commit('setProgress', response.data.data.progress)
        }
      } catch (e) {
        loading.value = false
        Helpers.processError(e, store, router)
      }
    }
    onMounted(() => {
      getLocation()
      effectSlider()
    })
    return {
      data,
      v$,
      choosedata,
      files,
      // progress,
      disabled,
      industries,
      businessmodel,
      fundinground,
      fundingtype,
      onSubmit,
      effectSlider,
      Helpers,
      loading,
      route,
      progress: computed(() => store.state.app.progress_status)
    }
  }
}
</script>

<style scoped>
input[type='range'] {
  width: 100%;
  height: 4px;
  -webkit-appearance: none;
  background-color: rgba(229, 230, 230, 1);
  border-radius: 5px;
  outline: none;
}

/* CHROME */
input[type='range']::-webkit-slider-runnable-track {
  -webkit-appearance: none;
  color: transparent;
}

input[type='range']::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 30px;
  height: 30px;
  cursor: pointer;
  z-index: 3;
  position: relative;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);
  transition: .3s ease-in-out;
  z-index: 3;
  outline: none;
}
/* input[type='range']::-moz-range-track-slider-thumb {
  -moz-appearance: none;
  appearance: none;
  outline: none;
} */

/* MOZ */
input[type='range']::-moz-range-thumb {
  width: 30px;
  height: 30px;
  appearance: none;
  -moz-appearance: none;
  outline: none;
  background: transparent;
  border: none;
}
input[type='range']:active::-webkit-slider-thumb {
  outline: none;
}
input[type="range"]::-moz-range-progress {
  height: 100%;
  border-radius: 5;
}
input[type="range"]::-moz-range-track {
  background-color: rgba(229, 230, 230, 1);
}
/* IE*/
input[type="range"]::-ms-fill-lower {
  background-color: #000000;
}
input[type="range"]::-ms-fill-upper {
  background-color: rgba(229, 230, 230, 1);
}
/* #fundingSlider:hover + #selector>.currentValue {
  opacity: 1;
} */
/* #selectValue::after {
  content: '';
  border-top: 8px solid #000;
  border-left: 8px solid #fff;
  border-right: 8px solid #fff;
  position: absolute;
  bottom: -8px;
  left: 32px;
} */
</style>
